// extracted by mini-css-extract-plugin
export default {"Container":"SimpleLayout__Container__NqujC","ContentWrapper":"SimpleLayout__ContentWrapper__8sl+w"};